import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IconName } from '@app/utils/models/enum/icon-name.enum';

@Component({
  selector: 'ess-icon',
  styleUrl: './icon.component.scss',
  templateUrl: './icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'iconClass$$()',
    '[style.font-variation-settings]': 'fontVariationSettings$$()',
    '[attr.aria-hidden]': "accessibleName$$() ? null : 'true'",
    '[attr.aria-label]': 'accessibleName$$() || null',
    '[attr.role]': "accessibleName$$() ? 'img' : null",
    '[attr.title]': 'trimmedTitle$$() || null',
  },
})
export class IconComponent {
  name$$ = input.required<IconName>({ alias: 'name' });

  ariaLabel$$ = input<string>('', { alias: 'ariaLabel' });
  className$$ = input<string>('', { alias: 'className' });
  fill$$ = input<0 | 1>(0, { alias: 'fill' });
  title$$ = input<string>('', { alias: 'title' });

  readonly accessibleName$$ = computed(() => {
    return this.trimmedTitle$$() || this.ariaLabel$$().trim();
  });

  readonly iconClass$$ = computed(() => {
    const className = this.className$$().trim();
    return className ? `material-icons-sharp ${className}` : 'material-icons-sharp';
  });

  readonly fontVariationSettings$$ = computed(() => {
    return `'FILL' ${this.fill$$()}`;
  });

  readonly trimmedTitle$$ = computed(() => {
    return this.title$$().trim();
  });
}
